var __WEBPACK_NAMESPACE_OBJECT__ = require("moment/min/locales");